import React from "react";
import CountUp from "react-countup";
import {
  Users, UserCheck, UserX, Briefcase, Banknote, HandCoins,
  PiggyBank, ArrowDownCircle, ArrowUpCircle, Shrink,
  ClockArrowDown, BadgeIndianRupee, Landmark, UserPlus,
  Wallet, Clock, Coins
} from "lucide-react";
import { StatCard, StatCardGrid } from "../../../components/ui";

const DashboardStats = ({ dashboardData }) => {
  return (
    <>
      <StatCardGrid cols={4} className="mb-6">
        <StatCard
          title="Total Customers"
          value={<CountUp end={dashboardData.totalCustomers || 0} duration={1} />}
          icon={<Users size={18} />}
          customBg="bg-[#E0F2FE]"
          customIconBg="inline-flex items-center justify-center w-8 h-8 rounded-full bg-[#BAE6FD] text-[#0284C7] flex-shrink-0"
          className="animated-glow-border border-glow-blue"
        />
        <StatCard
          title="Active Customers"
          value={<CountUp end={dashboardData.activeCustomersCount || 0} duration={1} />}
          icon={<UserCheck size={18} />}
          customBg="bg-[#DCFCE7]"
          customIconBg="inline-flex items-center justify-center w-8 h-8 rounded-full bg-[#BBF7D0] text-[#16A34A] flex-shrink-0"
          className="animated-glow-border border-glow-green"
        />
        <StatCard
          title="Inactive Customers"
          value={<CountUp end={dashboardData.inactiveCustomersCount || 0} duration={1} />}
          icon={<UserX size={18} />}
          customBg="bg-[#FEF3C7]"
          customIconBg="inline-flex items-center justify-center w-8 h-8 rounded-full bg-[#FDE68A] text-[#D97706] flex-shrink-0"
          className="animated-glow-border border-glow-amber"
        />
        <StatCard
          title="Opening Cash"
          value={<CountUp end={dashboardData.openingBalance?.yesterdayOutstanding || 0} duration={1} separator="," />}
          prefix="₹"
          icon={<Landmark size={18} />}
          customBg="bg-[#EDE9FE]"
          customIconBg="inline-flex items-center justify-center w-8 h-8 rounded-full bg-[#DDD6FE] text-[#7C3AED] flex-shrink-0"
          className="animated-glow-border border-glow-purple"
        />
        <StatCard
          title="New Customers"
          value={<CountUp end={dashboardData.newCustomersCount || 0} duration={1} separator="," />}
          icon={<UserPlus size={18} />}
          customBg="bg-[#FCE7F3]"
          customIconBg="inline-flex items-center justify-center w-8 h-8 rounded-full bg-[#FBCFE8] text-[#DB2777] flex-shrink-0"
          className="animated-glow-border border-glow-pink"
        />
        <StatCard
          title="Branch Payout"
          value={<CountUp end={Number(dashboardData.branchPayout) || 0} duration={1} separator="," />}
          prefix="₹"
          icon={<Wallet size={18} />}
          customBg="bg-[#E0E7FF]"
          customIconBg="inline-flex items-center justify-center w-8 h-8 rounded-full bg-[#C7D2FE] text-[#4F46E5] flex-shrink-0"
          className="animated-glow-border border-glow-indigo"
        />
        <StatCard
          title="EMI Collection"
          value={<CountUp end={dashboardData.emiPayout || 0} duration={1} separator="," />}
          prefix="₹"
          icon={<Clock size={18} />}
          customBg="bg-[#CCFBF1]"
          customIconBg="inline-flex items-center justify-center w-8 h-8 rounded-full bg-[#99F6E4] text-[#0D9488] flex-shrink-0"
          className="animated-glow-border border-glow-teal"
        />
        <StatCard
          title="Business Loans"
          value={<CountUp end={dashboardData.businessLoan || 0} duration={1} separator="," />}
          icon={<Briefcase size={18} />}
          customBg="bg-[#FFE4E6]"
          customIconBg="inline-flex items-center justify-center w-8 h-8 rounded-full bg-[#FECDD3] text-[#E11D48] flex-shrink-0"
          className="animated-glow-border border-glow-red"
        />
        <StatCard
          title="Savings Collections"
          value={<CountUp end={dashboardData.savingsCollections || 0} duration={1} separator="," />}
          prefix="₹"
          icon={<Coins size={18} />}
          customBg="bg-[#FEF9C3]"
          customIconBg="inline-flex items-center justify-center w-8 h-8 rounded-full bg-[#FEF08A] text-[#CA8A04] flex-shrink-0"
          className="animated-glow-border border-glow-amber"
        />
        <StatCard
          title="Total Arrear"
          value={<CountUp end={dashboardData.arrearsStats?.totalArrearAmount || 0} duration={1} separator="," />}
          prefix="₹"
          icon={<Clock size={18} />}
          customBg="bg-[#FEE2E2]"
          customIconBg="inline-flex items-center justify-center w-8 h-8 rounded-full bg-[#FECACA] text-[#DC2626] flex-shrink-0"
          className="animated-glow-border border-glow-red"
        />
        <StatCard
          title="Out Principal"
          value={
            <CountUp
              end={dashboardData.totalPendingPrincipal?.totalPendingPrincipal || 0}
              duration={1}
              separator=","
            />
          }
          prefix="₹"
          icon={<Shrink size={18} />}
          customBg="bg-[#DBEAFE]"
          customIconBg="inline-flex items-center justify-center w-8 h-8 rounded-full bg-[#BFDBFE] text-[#2563EB] flex-shrink-0"
          className="animated-glow-border border-glow-blue"
        />
        <StatCard
          title="Overdue EMIs"
          value={<CountUp end={dashboardData.arrearsStats?.totalArrears || 0} duration={1} separator="," />}
          icon={<Shrink size={18} />}
          customBg="bg-[#FFEDD5]"
          customIconBg="inline-flex items-center justify-center w-8 h-8 rounded-full bg-[#FED7AA] text-[#EA580C] flex-shrink-0"
          className="animated-glow-border border-glow-amber"
        />
      </StatCardGrid>

      <StatCardGrid cols={2} className="mb-8">
        <StatCard
          title="Total Withdrawals"
          value={
            <CountUp
              end={dashboardData.totalWithdrawals || 0}
              duration={1}
              separator=","
            />
          }
          prefix="₹"
          icon={<ArrowDownCircle size={22} />}
          customBg="bg-[#FFE4E6]"
          customIconBg="inline-flex items-center justify-center w-9 h-9 rounded-full bg-[#FECDD3] text-[#E11D48] flex-shrink-0"
          className="animated-glow-border border-glow-red"
        />
        <StatCard
          title="Total Deposit"
          value={
            <CountUp
              end={dashboardData.totalDeposits || 0}
              duration={1}
              separator=","
            />
          }
          prefix="₹"
          icon={<ArrowUpCircle size={22} />}
          customBg="bg-[#DCFCE7]"
          customIconBg="inline-flex items-center justify-center w-9 h-9 rounded-full bg-[#BBF7D0] text-[#16A34A] flex-shrink-0"
          className="animated-glow-border border-glow-green"
        />
      </StatCardGrid>
    </>
  );
};

export default DashboardStats;
